import { render, staticRenderFns } from "./Adviser.vue?vue&type=template&id=c0852812&scoped=true&"
import script from "./Adviser.vue?vue&type=script&lang=js&"
export * from "./Adviser.vue?vue&type=script&lang=js&"
import style0 from "./Adviser.vue?vue&type=style&index=0&id=c0852812&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0852812",
  null
  
)

export default component.exports